import { createFileRoute } from "@tanstack/react-router"

// Matches every /setup/* path so the parent's redirect runs for it.
export const Route = createFileRoute("/_auth/setup/$")({})
